module.exports = __webpack_public_path__ + "static/media/info2.cf24b89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stores/steps/info2.png
// module id = 329
// module chunks = 0